@import '~style-sheet-helpers/core.less';
@import '../actionable-filter-pill/actionable-filter-pill.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.overflow-bar-wrapper,
.filter-bar-wrapper {
  display: flex;
  align-items: center;
}

.overflow-bar-wrapper {
  width: 100%;
}

.filters-with-overflow {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.dropdowns-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: auto;

  > div {
    margin: 2px;
  }
}

.popular-filter-form {
  position: relative;
  max-height: 600px;
}

.filter-by-label {
  font-size: 14px;
  margin-right: 10px;
  white-space: nowrap;
}

.clear-filters-button {
  margin-left: 10px;
  min-width: 100px;
  min-height: 28px;
  color: @filter-bar--clear-button--text-color;
  font-weight: 500;
  display: flex;
  align-items: center;

  svg {
    fill: @filter-bar--clear-button--fill-color;
    height: 15px;
    width: 15px;
    padding-right: 3px;
  }
}

.saved-filters-dropdown {
  border: 1px solid @filter-bar--saved-dropdown--border-color;
  border-radius: 4px;
  max-height: 320px;
  overflow: auto;
}

.saved-filters-toggler {
  padding-left: 5px;
  color: @filter-bar--saved-toggler--text-color;

  svg {
    fill: @filter-bar--saved-toggler--fill-color;
  }
}

.other-filter-options-toggle {
  .filter-bar-styling();
}

.link-item {
  color: @filter-bar--link--text-color;

  &:hover {
    text-decoration: underline;
    color: @filter-bar--link--hover--text-color;
  }
}
